import { getApiUrl } from "./apiHelper";
import { getAppLang } from "./appLanguage";

const PROFILE_TYPE_TO_RECOMM_FOR = {
  prompts_docs_llm: "full",
  ai_model_attack_surface: "llm",
  mcp_tester: "mcp",
  dos_tester: "dos",
  rto: "rto",
  regulation_compliance: "reg",
};

/**
 * Map report profile_type to the recomm_for query param used by recs/PDF APIs.
 * @param {string} profileType
 * @returns {string|null}
 */
export function getRecommForFromProfileType(profileType) {
  if (!profileType) return null;
  return PROFILE_TYPE_TO_RECOMM_FOR[profileType] || null;
}

/**
 * Fetch the server-generated PDF and trigger a browser download.
 * @param {{ reportId: string|number, profileType: string, fileName?: string, consolidation?: boolean }} options
 */
export async function downloadPdfReport({ reportId, profileType, fileName, consolidation = false }) {
  if (!reportId) {
    throw new Error("Report ID not found.");
  }

  const recommFor = getRecommForFromProfileType(profileType);
  if (!recommFor) {
    throw new Error(`PDF download is not available for profile type: ${profileType || "unknown"}`);
  }

  const response = await fetch(
    getApiUrl(
      `/api/internal/readiness-score/pdf-report/?recomm_for=${recommFor}&report_id=${reportId}&consolidation=${Boolean(consolidation)}&lang=${getAppLang()}`
    ),
    {
      method: "GET",
      credentials: "include",
      redirect: "follow",
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Failed to generate PDF (status ${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  const reportKind = consolidation ? "consolidated" : "individual";
  link.download = fileName || `pdf_report_${reportKind}_${reportId}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
